<template>
     <li>
        <article class="event" :class="e.image ? 'has-image' : 'no-image'">
<div class="event-content">
            <div class="summary formatting">
              <h4>
                <a
                  :href="wwwUrl(e.url)"
                  title="See event details"
                  >{{e.title}}</a
                >
              </h4>
              <p v-if="e.blurb && e.blurb != 'null'">{{e.blurb}}</p>
              <p v-else-if="e.description && e.description != 'null'">{{e.description}}</p>
  
              <p class="meta venue" v-if="e.location">
                <span class="icon-pin"></span>{{e.location}}</p>
  
              <div class="meta audience" v-if="e.eventAudience" v-html="audienceTags(e.eventAudience)">
              </div>
                        <p class="event-tag" v-if="e.collection == 'squiz' && e.eventOwner != siteName && e.eventOwner != 'Events' ">
              This event comes from
              <a :href="wwwUrl(e.eventOwnerEventsLink)">{{e.eventOwner}}</a>
            </p>
  
            <p class="event-tag" v-else-if="e.eventOwner == 'Events' ">
              This event comes from the University's main 
              <a href="https://www.wgtn.ac.nz/events">{{e.eventOwner.toLowerCase()}} </a> page.
            </p>
            
            <svg width="81" class="pattern" height="78" viewBox="0 0 143 138" fill="none" xmlns="http://www.w3.org/2000/svg" data-v-db00fc03=""><g clip-path="url(#clip0_50:63)" data-v-db00fc03=""><path d="M142.955 0H71.478C96.229 23.868 119.695 46.495 142.956 68.924L142.955 0Z" fill="#ccdcd7" data-v-db00fc03=""></path><path d="M71.477 0H0C24.751 23.868 48.217 46.495 71.478 68.924L71.477 0Z" fill="#F6F6F6" data-v-db00fc03=""></path><path d="M142.954 68.924H71.4771C96.2281 92.792 119.694 115.419 142.955 137.848L142.954 68.924Z" fill="#F6F6F6" data-v-db00fc03=""></path></g><defs data-v-db00fc03=""><clipPath id="clip0_50:63" data-v-db00fc03=""><rect width="142.955" height="137.849" fill="white" data-v-db00fc03=""></rect></clipPath></defs></svg>
            </div>
           
</div>

          <figure class="image" v-if="e.image">
                  <img :src="e.image" :title="e.title"
                    :data-copyright-show="e.imageShowCopyright"
                    :data-copyright-url="e.imageCopyrightUrl"
                    :data-copyright-text="e.imageCopyrightText"
                  >
              </figure>



              <div class="margin-notes">
              <time class="highlight-strip">
                <div v-if="e.eventType" v-html="formatEventType(e.eventType)" class="event-type"> </div>
            
            <!-- {{e.collection}} -->
            
                <span class="date" > {{ compareDates(e.startDate, e.endDate) }} </span>
  
              <!-- REMOVE~~~~~~~~~~~~~~~~~~~~~~~~~ -->
                <!-- <span class="date" v-if="e.startDate && !e.endDate "> {{ formatDate(e.startDate, 'D MMM YYYY') }} </span>
                
                <span class="date" v-else-if="e.startDate == e.endDate || formatDate(e.startDate, 'YYYY') > formatDate(e.endDate, 'YYYY')"> {{ formatDate(e.startDate, 'D MMM YYYY') }} </span>
  
                <span class="date" v-else-if="e.startDate && e.endDate "> {{formatDate(e.startDate, 'D MMM')}} - {{ formatDate(e.endDate, 'D MMM YYYY') }} </span> -->
  
                <span class="time" v-if="e.startTime">from {{e.startTime.replace(' ','')}} 
                  <!-- <span v-if="e.endTime">to {{e.endTime.replace(' ','')}}</span> -->
                  </span>
              </time>
            </div>

        </article>
              </li>
</template>

<script>
var dayjs = require("dayjs");

export default {
  name: "EventNew",
  props: ["e", "index"],
  methods: {
    formatDate(date) {
      let d = dayjs(date).format("D MMMM YYYY");
      return `${d}`;
    },
    wwwUrl(url) {
      return url.replace("cms", "www");
    },
    formatEventType(type) {
      if (type.includes(";")) {
        let types = type
          .split(";")
          .map((t) => `<span class="type-tag">${t.trim()}</span>`)
          .join("");
        return types;
      } else {
        return `<span>${type}</span>`;
      }
    },
    audienceTags(e) {
      let tagHtml = e
        .split(";")
        .map((tag) => `<span class="tag tag-grey mr1">${tag}</span>`)
        .join("");
      return tagHtml;
    },
    compareDates(sD, eD) {
      if (sD && !eD) {
        return dayjs(sD).format("D MMM YYYY");
      } else if (sD >= (eD && dayjs(eD).isValid())) {
        return dayjs(sD).format("D MMM YYYY");
      } else {
        return `${dayjs(sD).format("D MMM")} - ${dayjs(eD).format(
          "D MMM YYYY"
        )}`;
      }
    },
  },
};
</script>

<style lang="scss" >
@import "./src/styles/_variables.scss";
#hubv4 {
  .events {
    margin-top: 1rem;
    > li {
      border: none;
      padding-bottom: 0;
      margin-bottom: 1.5rem;
    }
  }

  .event {
    margin-bottom: 0 !important;
    background-color: $off-white;
    display: grid;
    grid-template-columns: 2fr 1fr;
    position: relative;
    box-shadow: 0 4px 8px -2px rgb(9 30 66 / 25%), 0 0 0 1px rgb(9 30 66 / 8%);
    // border-left: 5px solid $kowhai;

    svg {
      position: absolute;
      top: 0;
      right: 0;
      opacity: .7;
    }
    h4 {
    margin-bottom: 1rem;
      a {
        color: $pounamu;
      }
    }
    .audience {
      .tag {
        background-color: $miro;
        color: #262524;
      }
    }

    &.no-image {
      grid-template-columns: 1fr;
      .summary {
        grid-column: 1/3;
      }
    }

    .tag {
      margin-top: 0.5rem;
      font-size: 0.8rem;
      margin-left: 10;
      background-color: $kohuhu;
    }

    &:not(:last-child) {
      margin-bottom: 1.5rem;
      padding-bottom: 1.5rem;
      border-bottom: 0.0625rem solid #ddd;
    }

    .summary {
      width: 100%;
      padding: 1rem;
      background-color: $off-white;
    }
    
    .image {
      width: 100%;
      background-color: $off-white;

      img {
        width: 100%;
        margin-bottom: 0;
        object-fit: fill;
        //  object-position: left;
        @media only screen and (max-width: 900px) {
          object-fit: contain;
           object-position: top;

      }
      @media only screen and (max-width: 700px) {

      }
      }
    }

    .margin-notes {
      grid-column: 1/3;
      width: 100%;
      padding-right: 0;
      margin-bottom: 0;

      .highlight-strip {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        background-color: $kohuhu;
        border-color: $mahoe;

        .date {
          margin-bottom: 0;
          margin-right: 1rem;
          color: $pounamu;
        }
        .time {
          color: $pounamu;
        }

        .event-type {
          width: 100%;

          span {
            color: #242625;
          }
        }
      }
    }

    @media only screen and (max-width: 700px) {
      grid-template-columns: 1fr;
      .event-content {
        grid-column: 1/2;
        // order: 0;
      }
      .image {
        grid-row: 1/2;
      }
    }
  }
}
</style>